// JavaScript для contacts
import { onReady } from '../base/init.js';

onReady(function () {
  // Код для contacts
});
